import React from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Platform } from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import { useTheme } from '@theme/ThemeProvider';

// Screen imports
import HomeScreen from '@screens/HomeScreen';
import JourneysScreen from '@screens/JourneysScreen';
import InboxScreen from '@screens/InboxScreen';
import ProfileScreen from '@screens/ProfileScreen';
import { MainTabParamList } from './types';

const Tab = createBottomTabNavigator<MainTabParamList>();

export const BottomTabNavigator: React.FC = () => {
  const theme = useTheme();

  // Convert elevation to web-compatible styles
  const elevationStyle =
    Platform.OS === 'web'
      ? {
          boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
        }
      : theme.elevation.sm;

  return (
    <Tab.Navigator
      screenOptions={{
        headerShown: false,
        tabBarActiveTintColor: theme.colors.brandPrimary,
        tabBarInactiveTintColor: theme.colors.textSecondary,
        tabBarStyle: {
          backgroundColor: theme.colors.surface,
          borderTopColor: theme.colors.border,
          borderTopWidth: 1,
          height: 84,
          paddingBottom: theme.spacing.xl,
          paddingTop: theme.spacing.sm,
          paddingHorizontal: theme.spacing.xs,
          ...elevationStyle,
        },
        tabBarLabelStyle: {
          fontSize: theme.typography.caption.fontSize,
          fontWeight: theme.typography.button.fontWeight,
          marginTop: theme.spacing.xs,
        },
        tabBarIconStyle: {
          marginTop: theme.spacing.xs,
        },
      }}
    >
      <Tab.Screen
        name="Home"
        component={HomeScreen}
        options={{
          tabBarIcon: ({ color }) => <Icon name="home" size={24} color={color} />,
          tabBarLabel: 'Home',
        }}
      />
      <Tab.Screen
        name="Journeys"
        component={JourneysScreen}
        options={{
          tabBarIcon: ({ color }) => <Icon name="explore" size={24} color={color} />,
          tabBarLabel: 'Journeys',
        }}
      />
      <Tab.Screen
        name="Inbox"
        component={InboxScreen}
        options={{
          tabBarIcon: ({ color }) => <Icon name="notifications" size={24} color={color} />,
          tabBarLabel: 'Inbox',
          tabBarBadge: undefined, // Can be set dynamically with unread count
        }}
      />
      <Tab.Screen
        name="Profile"
        component={ProfileScreen}
        options={{
          tabBarIcon: ({ color }) => <Icon name="person" size={24} color={color} />,
          tabBarLabel: 'Profile',
        }}
      />
    </Tab.Navigator>
  );
};
